import { render, staticRenderFns } from "./HeaderMenuReportPanel.vue?vue&type=template&id=20155d8b&scoped=true"
import script from "./HeaderMenuReportPanel.vue?vue&type=script&lang=js"
export * from "./HeaderMenuReportPanel.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenuReportPanel.vue?vue&type=style&index=0&id=20155d8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20155d8b",
  null
  
)

export default component.exports